import zappy from "@zappy-ride/library.react.components";
import FormVehicleSets from "./FormVehicleSets";

export * from "./FormVehicleSets";

zappy.FactoryInstance.registerComponent(FormVehicleSets);
